/*
 * @Author: your name
 * @Date: 2020-08-06 15:48:35
 * @LastEditTime: 2020-08-07 14:32:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/mixin/form-data-change.mixin.js
 */
export default {
  data() {
    return {
      sourceDataStr: null,
      routeLeaveWriteList: [
        'appList',
        'form'
      ]
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$globalScanModal && this.$globalScanModal.visible === true) {
      this.$scanModalOptEvent && this.$scanModalOptEvent.dismissGlobalModal()
      next(false)
    } else if (this.routeLeaveWriteList.includes(to.name)) {
      if (this.formBtnList.filter((btn) => btn.type === 'SAVE').length > 0) {
        if (this.sourceDataStr !== JSON.stringify(this.formData)) {
          this.handleRouteLeave('SAVE').then(() => {
            next(true)
          }).catch(() => {
            next(false)
          })
        } else {
          next(true)
        }
      } else if (this.formBtnList.filter((btn) => btn.type === 'SUBMIT').length > 0) {
        if (this.sourceDataStr !== JSON.stringify(this.formData)) {
          this.handleRouteLeave('SUBMIT').then(() => {
            next(true)
          }).catch(() => {
            next(false)
          })
        } else {
          next(true)
        }
      } else {
        next(true)
      }
    } else {
      next(true)
    }
  },
  methods: {
    setSourceDataStr(sourceData) {
      setTimeout(() => {
        this.sourceDataStr = JSON.stringify(sourceData)
      }, 1000)
    }
  }
}
